module.exports = __webpack_public_path__ + "img/infinite-sharp.297b2991.svg";